export default __webpack_public_path__ + "619e040bc569e978f6da03a3edf30e93.png";